import React, { useState } from "react";
import { formatDateAndTime } from "../../_App/Helpers/helpers";
import { useNavigate } from "react-router-dom";
import TransfertAnnomalie from "./TransfertAnnomalie";
import DemandeRemiseIncident from "./DemandeRemiseIncident";
import DemandeAnnulationIncident from "./DemandeAnnulationIncident";
import DemandeRetourIncident from "./DemandeRetourIncident";
import { Modal } from "react-bootstrap";

export default function IncidentList({
  list,
  t,
  societe_id,
  ids,
  setListIds,
  marqueAsSeen,
  etat,
}: any) {
  const [showtransfertAnnomalie, setshowtransfertAnnomalie] = useState(false);
  const [showModalDemandeRemise, setshowModalDemandeRemise] = useState(false);
  const [showModalDemande_annulation, setshowModalDemande_annulation] =
    useState(false);
  const [showModalDemandeRetour, setshowModalDemandeRetour] = useState(false);
  const [showModalTiroir, setshowModalTiroir] = useState(false);
  const [tiroirInc, settiroirInc] = useState<any>();

  const [incident, setincident] = useState();
  const [commande, setcommande] = useState();
  const [showCheckBox, setCheckBox] = useState(false);

  const detailIncident = (inc: any) => {
    if (inc.action === "Demande remise") {
      setcommande(inc?.demande_Remise_id);

      setshowModalDemandeRemise(true);
    } else if (inc.action === "Demande annulation") {
      setcommande(inc);

      setshowModalDemande_annulation(true);
    } else if (inc.action === "Demande retour") {
      setcommande(inc);

      setshowModalDemandeRetour(true);
    } else if (inc.action === "Tiroir") {
      settiroirInc(inc);
      setshowModalTiroir(true);
    } else {
      setincident(inc);
      setshowtransfertAnnomalie(true);
    }
  };
  const toggleId = (id: string) => {
    setListIds((prev: string[]) => {
      if (prev.includes(id)) {
        return prev.filter((x) => x !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const selectAll = () => {
    if (list && list.length > 0) {
      const allIds = list.map((item: any) => item._id);
      setListIds(allIds);
    }
  };

  const deselectAll = () => {
    setListIds([]);
  };

  return (
    <div>
      <div className="row layout-spacing mt-4">
        <div className="col-lg-12   bg-white  ">
          <div className="d-flex justify-content-end mt-2 mb-2">
            <div className="d-flex justify-content-end mb-3 gap-2">
              {showCheckBox ? (
                <>
                  {ids.length !== list.length ? (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={selectAll}
                    >
                      {t("Tout sélectionner")}
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={deselectAll}
                    >
                      {t("Tout désélectionner")}
                    </button>
                  )}
                </>
              ) : (
                etat !== "true" && (
                  <button
                    className="btn btn-primary-app"
                    onClick={() => setCheckBox(true)}
                  >
                    {t("Marquer à vu")}
                    <i className="fas fa-eye ms-2"></i>
                  </button>
                )
              )}
            </div>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                {showCheckBox && <th></th>}
                <th>{t("Type")}</th>
                <th>{t("Action")}</th>
                <th>{t("message")}</th>
                <th>{t("confirmer")}</th>
                <th>{t("Date")}</th>
              </thead>

              <tbody>
                {list &&
                  list.map((item: any) => (
                    <tr>
                      {showCheckBox && !item.seen && (
                        <td>
                          <input
                            type="checkbox"
                            checked={ids.includes(item._id)}
                            onChange={() => toggleId(item._id)}
                          />
                        </td>
                      )}
                      <td
                        className="lien-bleu-souligne"
                        onClick={() => detailIncident(item)}
                      >
                        {item.type}
                      </td>
                      <td>{item.action}</td>
                      <td>
                        {item.type === "demande"
                          ? item?.demande?.msg
                          : item?.anomalie?.msg}
                      </td>
                      <td>
                        {item?.confirmed
                          ? item?.confirmed?.valide
                            ? "confirmé"
                            : "non confirmé"
                          : "en cours"}
                      </td>
                      <td>{formatDateAndTime(item?.createdAt)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="d-flex justify-content-end mb-3 gap-2">
              {showCheckBox && (
                <>
                  <button
                    className="btn btn-primary-app"
                    onClick={() => {
                      setListIds([]);
                      setCheckBox(false);
                    }}
                  >
                    {t("Annuler")}
                  </button>
                  <button
                    className="btn btn-primary-app"
                    onClick={marqueAsSeen}
                  >
                    {t("Enregistrer à vu")}
                    <i className="fas fa-eye ms-2"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showtransfertAnnomalie && (
        <TransfertAnnomalie
          societe_id={societe_id}
          showModal={showtransfertAnnomalie}
          setshowModal={setshowtransfertAnnomalie}
          annomalie={incident}
          t={t}
        />
      )}

      {showModalDemandeRemise && (
        <DemandeRemiseIncident
          showModal={showModalDemandeRemise}
          setshowModal={setshowModalDemandeRemise}
          commande={commande}
          t={t}
        />
      )}
      {showModalDemande_annulation && (
        <DemandeAnnulationIncident
          showModal={showModalDemande_annulation}
          setshowModal={setshowModalDemande_annulation}
          commande={commande}
          t={t}
        />
      )}
      {showModalDemandeRetour && (
        <DemandeRetourIncident
          showModal={showModalDemandeRetour}
          setshowModal={setshowModalDemandeRetour}
          commande={commande}
          t={t}
        />
      )}
      {showModalTiroir && (
        <Modal
          show={showModalTiroir}
          onHide={() => {
            setshowModalTiroir(false);
          }}
          style={{ display: "flex", justifyContent: "center" }}
          size="lg"
        >
          <Modal.Header>{t("Tiroir action")}</Modal.Header>
          <Modal.Body>
            <div className="container center-text">
              <div className="row ">
                <div className="col-4">
                  <label>{t("User :")}</label>
                  {tiroirInc?.Objet?.user.nom +
                    " " +
                    tiroirInc?.Objet?.user.prenom}
                </div>
                <div className="col-4">
                  <label>{t("Date :")}</label>
                  {formatDateAndTime(tiroirInc?.Objet?.date)}
                </div>
                <div className="col-4">
                  <label>{t("Organisation :")}</label>
                  {tiroirInc?.Objet?.organisation?.nom}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}
